// src/components/one-key-burn-switch/one-key-burn-switch.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n    title\n    withBackground\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSIllustrationFragment on Illustration {\n    description\n    id\n    link: url\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSMarkFragment on Mark {\n    description\n    id\n    markSize: size\n    url {\n      ... on HttpURI {\n        __typename\n        relativePath\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...EGDSIconFragment\n    }\n\n    ... on Mark {\n      ...EGDSMarkFragment\n    }\n\n    ... on Illustration {\n      ...EGDSIllustrationFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSwitchFragment on EGDSStandardSwitch {\n    enabled\n    checked\n    checkedLabel\n    uncheckedLabel\n    checkedDescription\n    uncheckedDescription\n    checkedAccessibilityLabel\n    uncheckedAccessibilityLabel\n    checkedAnalytics {\n      linkName\n      referrerId\n    }\n    uncheckedAnalytics {\n      linkName\n      referrerId\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    eventType\n    linkName\n    referrerId\n    uisPrimeMessages {\n      messageContent\n      schemaName\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment OneKeyBurnSwitchFragment on OneKeyBurnSwitch {\n    burnSwitchGraphic: graphic {\n      ...EGDSGraphicFragment\n    }\n    switch {\n      ...EGDSSwitchFragment\n    }\n    impressionTracking {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
import React6 from "react";
import { gql as gql7 } from "@apollo/client";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/egds-graphic/egds-graphic.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
// ../internal/src/components/egds-graphic/egds-icon.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
var __EGDSIconFragment = gql(_templateObject());
var EGDSIcon = function(param) {
    var className = param.className, theme = param.theme, data = param.data;
    var spotlight = (data === null || data === void 0 ? void 0 : data.withBackground) ? "info" : void 0;
    var _data_title;
    return /* @__PURE__ */ React.createElement(UitkIcon, {
        className: className,
        description: data === null || data === void 0 ? void 0 : data.description,
        id: data === null || data === void 0 ? void 0 : data.id,
        name: data !== null ? data.id : "",
        size: (data === null || data === void 0 ? void 0 : data.size) ? UitkIconSize[data.size] : void 0,
        title: (_data_title = data === null || data === void 0 ? void 0 : data.title) !== null && _data_title !== void 0 ? _data_title : void 0,
        theme: theme || (data === null || data === void 0 ? void 0 : data.theme) || void 0,
        spotlight: spotlight
    });
};
EGDSIcon.displayName = "EGDSIcon";
EGDSIcon.fragment = __EGDSIconFragment;
// ../internal/src/components/egds-graphic/egds-illustration.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkIllustrations } from "uitk-react-illustrations";
var __EGDSIllustrationFragment = gql2(_templateObject1());
var EGDSIllustration = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React2.createElement(UitkIllustrations, {
        alt: data.description,
        url: data.link
    });
};
EGDSIllustration.displayName = "Illustration";
EGDSIllustration.fragment = __EGDSIllustrationFragment;
// ../internal/src/components/egds-graphic/egds-mark.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkMark, UitkMarkSize } from "uitk-react-mark";
var __EGDSMarkFragment = gql3(_templateObject2());
var EGDSMark = function(param) {
    var className = param.className, markSize = param.markSize, data = param.data;
    var _data_url;
    return /* @__PURE__ */ React3.createElement(UitkMark, {
        className: className,
        description: data.description,
        id: data.id,
        name: data.id,
        size: markSize || data.markSize && UitkMarkSize[data.markSize],
        url: (_data_url = data.url) === null || _data_url === void 0 ? void 0 : _data_url.value
    });
};
EGDSMark.displayName = "EGDSMark";
EGDSMark.fragment = __EGDSMarkFragment;
// ../internal/src/components/egds-graphic/egds-graphic.tsx
var __EGDSGraphicFragment = gql4(_templateObject3(), EGDSIcon.fragment, EGDSMark.fragment, EGDSIllustration.fragment);
var EGDSGraphic = function(param) {
    var className = param.className, markSize = param.markSize, data = param.data;
    switch(data.__typename){
        case "Icon":
            return /* @__PURE__ */ React4.createElement(EGDSIcon, {
                className: className,
                data: data
            });
        case "Mark":
            return /* @__PURE__ */ React4.createElement(EGDSMark, {
                className: className,
                data: data,
                markSize: markSize
            });
        case "Illustration":
            return /* @__PURE__ */ React4.createElement(EGDSIllustration, {
                data: data
            });
        default:
            return null;
    }
};
EGDSGraphic.displayName = "EGDSGraphic";
EGDSGraphic.fragment = __EGDSGraphicFragment;
// ../internal/src/components/egds-switch/egds-switch.tsx
import React5, { useEffect } from "react";
import { gql as gql5 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkSwitch } from "uitk-react-switch";
import { UitkText } from "uitk-react-text";
var fragment = gql5(_templateObject4());
var EGDSSwitch = function(param) {
    var switchHandler = param.switchHandler, id = param.id, switchPosition = param.switchPosition, weight = param.weight, data = param.data;
    var enabled = data.enabled, checked = data.checked, checkedLabel = data.checkedLabel, uncheckedLabel = data.uncheckedLabel, checkedAnalytics = data.checkedAnalytics, uncheckedAnalytics = data.uncheckedAnalytics, checkedDescription = data.checkedDescription, uncheckedDescription = data.uncheckedDescription, checkedAccessibilityLabel = data.checkedAccessibilityLabel, uncheckedAccessibilityLabel = data.uncheckedAccessibilityLabel;
    var _React5_useState = _sliced_to_array(React5.useState(checked), 2), isChecked = _React5_useState[0], setIsChecked = _React5_useState[1];
    useEffect(function() {
        return setIsChecked(checked);
    }, [
        checked
    ]);
    var clickTracker = useClickTracker();
    var handleSwitch = function() {
        setIsChecked(!isChecked);
        switchHandler(!isChecked);
        if (checkedAnalytics && !isChecked) {
            clickTracker(checkedAnalytics.referrerId, checkedAnalytics.linkName);
        } else if (uncheckedAnalytics && isChecked) {
            clickTracker(uncheckedAnalytics.referrerId, uncheckedAnalytics.linkName);
        }
    };
    var label = isChecked ? checkedLabel : uncheckedLabel;
    var a11yLabel = isChecked ? checkedAccessibilityLabel : uncheckedAccessibilityLabel;
    var description = isChecked ? checkedDescription : uncheckedDescription;
    var _ref;
    return /* @__PURE__ */ React5.createElement(UitkSwitch, {
        id: id,
        checked: isChecked,
        onChange: handleSwitch,
        switchPosition: switchPosition || "trailing",
        disabled: !enabled,
        a11yLabel: (_ref = a11yLabel !== null && a11yLabel !== void 0 ? a11yLabel : label) !== null && _ref !== void 0 ? _ref : void 0,
        description: description !== null && description !== void 0 ? description : void 0
    }, /* @__PURE__ */ React5.createElement(UitkText, {
        weight: weight || "medium",
        size: 400
    }, label !== null && label !== void 0 ? label : ""));
};
EGDSSwitch.fragment = fragment;
EGDSSwitch.displayName = "EGDSSwitch";
// ../internal/src/utils/client-side-analytics.ts
import { gql as gql6 } from "@apollo/client";
var ClientSideAnalyticsFragment = gql6(_templateObject5());
// src/components/one-key-burn-switch/one-key-burn-switch.tsx
import { UitkCard, UitkCardContentSection } from "uitk-react-cards";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
var fragment2 = gql7(_templateObject6(), EGDSGraphic.fragment, EGDSSwitch.fragment, ClientSideAnalyticsFragment);
var OneKeyBurnSwitch = function(param) {
    var data = param.data, _param_markSize = param.markSize, markSize = _param_markSize === void 0 ? 11 : _param_markSize, handler = param.handler, className = param.className;
    var burnSwitchGraphic = data.burnSwitchGraphic, impressionTracking = data.impressionTracking;
    var egdsGraphic = burnSwitchGraphic && /* @__PURE__ */ React6.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React6.createElement(EGDSGraphic, {
        data: burnSwitchGraphic,
        markSize: markSize
    }));
    var loyaltySwitch = data.switch && /* @__PURE__ */ React6.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React6.createElement(UitkSpacing, {
        margin: {
            inlinestart: burnSwitchGraphic ? "three" : "unset"
        }
    }, /* @__PURE__ */ React6.createElement("div", {
        "data-stid": "one-key-burn-switch"
    }, /* @__PURE__ */ React6.createElement(EGDSSwitch, {
        data: data.switch,
        id: "loyalty-switch",
        switchPosition: "trailing",
        weight: "medium",
        switchHandler: handler !== null && handler !== void 0 ? handler : function() {
            return null;
        }
    }))));
    var BurnSwitch = /* @__PURE__ */ React6.createElement(UitkCard, {
        className: className,
        border: true
    }, /* @__PURE__ */ React6.createElement(UitkCardContentSection, null, /* @__PURE__ */ React6.createElement(UitkSpacing, {
        padding: {
            block: burnSwitchGraphic ? "one" : "unset",
            inline: burnSwitchGraphic ? "one" : "unset"
        }
    }, /* @__PURE__ */ React6.createElement(UitkLayoutFlex, {
        alignItems: "center"
    }, egdsGraphic, loyaltySwitch))));
    if (impressionTracking) {
        var referrerId = impressionTracking.referrerId, linkName = impressionTracking.linkName;
        return /* @__PURE__ */ React6.createElement(IntersectionTracker, {
            referrerId: referrerId,
            linkName: linkName,
            intersectionOptions: {
                threshold: 0.5
            }
        }, BurnSwitch);
    }
    return /* @__PURE__ */ React6.createElement(React6.Fragment, null, BurnSwitch);
};
OneKeyBurnSwitch.fragment = fragment2;
OneKeyBurnSwitch.displayName = "sharedui-OneKeyBurnSwitch";
export { OneKeyBurnSwitch };
//# sourceMappingURL=index.js.map